import { render, staticRenderFns } from "./Borc.vue?vue&type=template&id=4f905582"
import script from "./Borc.vue?vue&type=script&lang=js"
export * from "./Borc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports